import { SchoolAdminManagePage } from "./page"

export default SchoolAdminManagePage
